var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-curvey"},[_c('h2',[_vm._v("Campaigns (Last 30 Campaigns)")]),_c('apex-chart',{attrs:{"type":"bar","height":400,"options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }